export interface CategoryColors {
  border: string;
  checkBg: string;
  checkBorder: string;
  iconBg: string;
  tabActiveBg: string;
  tabActiveText: string;
  tabInactiveBg: string;
  tabInactiveText: string;
  spinnerBorder: string;
  svgColor: string;
}

import { CATEGORY } from './categories.constants';

// Flooring, Drywall, and Interior Paint all share var(--talos-accent) for svgColor so
// detection overlays read as the same color across categories.

const FLOORING_COLORS: CategoryColors = {
  border:          'border-[rgba(218,62,62,0.2)]',
  checkBg:         'bg-talos-accent',
  checkBorder:     'border-talos-accent',
  iconBg:          'bg-talos-accent',
  tabActiveBg:     'bg-[rgba(218,62,62,0.08)]',
  tabActiveText:   'text-talos-accent',
  tabInactiveBg:   'bg-transparent',
  tabInactiveText: 'text-talos-ink/70',
  spinnerBorder:   'border-talos-accent',
  svgColor:        'var(--talos-accent)',
};

const DRYWALL_COLORS: CategoryColors = {
  border:          'border-[rgba(218,62,62,0.2)]',
  checkBg:         'bg-talos-accent',
  checkBorder:     'border-talos-accent',
  iconBg:          'bg-talos-accent',
  tabActiveBg:     'bg-[rgba(218,62,62,0.08)]',
  tabActiveText:   'text-talos-accent',
  tabInactiveBg:   'bg-transparent',
  tabInactiveText: 'text-talos-ink/70',
  spinnerBorder:   'border-talos-accent',
  svgColor:        'var(--talos-accent)',
};

const INTERIOR_PAINT_COLORS: CategoryColors = {
  border:          'border-[rgba(150,29,29,0.2)]',
  checkBg:         'bg-talos-accent',
  checkBorder:     'border-talos-accent',
  iconBg:          'bg-talos-accent',
  tabActiveBg:     'bg-[rgba(150,29,29,0.08)]',
  tabActiveText:   'text-talos-accent',
  tabInactiveBg:   'bg-transparent',
  tabInactiveText: 'text-talos-ink/70',
  spinnerBorder:   'border-talos-accent',
  svgColor:        'var(--talos-accent)',
};

const DEFAULT: CategoryColors = INTERIOR_PAINT_COLORS;

const MAP: Record<string, CategoryColors> = {
  [CATEGORY.FLOORING.id]:       FLOORING_COLORS,
  [CATEGORY.DRYWALL.id]:        DRYWALL_COLORS,
  [CATEGORY.INTERIOR_PAINT.id]: INTERIOR_PAINT_COLORS,
  [CATEGORY.FIXTURES.id]:       { ...DEFAULT, svgColor: 'var(--talos-accent)' },
  [CATEGORY.DOORS_WINDOWS.id]:  { ...DEFAULT, svgColor: 'rgb(var(--talos-ink-rgb) / 0.45)' },
  [CATEGORY.HVAC.id]:           { ...DEFAULT, svgColor: 'var(--talos-accent)' },
  [CATEGORY.COLUMNS.id]:        { ...DEFAULT, svgColor: 'var(--talos-accent)' },
  [CATEGORY.STEEL_BEAMS.id]:    { ...DEFAULT, svgColor: 'var(--talos-accent)' },
};

export function catColors(categoryId: string): CategoryColors {
  return MAP[categoryId] ?? DEFAULT;
}
